import React from 'react';
import dayjs from 'dayjs';

import type { Locale } from '@shaojiang/types/i18n';

interface Props {
  dateString: string | undefined;
  withDay?: boolean;
  /** Spell the month for this locale ("Jun 2024", "2024年6月") instead of "2024/06" */
  locale?: Locale;
}

export const formatDate = (date: string, locale: Locale, withDay = false) =>
  new Intl.DateTimeFormat(locale === 'zh' ? 'zh-CN' : 'en-US', {
    year: 'numeric',
    month: 'short',
    ...(withDay && { day: 'numeric' }),
    timeZone: 'UTC',
  }).format(new Date(date));

export default function ShaojiangDate({ dateString, withDay, locale }: Props) {
  if (!dateString) {
    return 'Now';
  }

  const text = locale
    ? formatDate(dateString, locale, withDay)
    : dayjs(dateString).format(`YYYY/MM${withDay ? '/DD' : ''}`);

  return <time dateTime={dateString}>{text}</time>;
}
